import React, { useState, useEffect } from 'react';

// Import CSS & assets
import ico_dots from '../../../../assets/ico/ico_dots.svg';
import ico_close from '../../../../assets/ico/ico_close.svg';
import ico_duplicate from '../../../../assets/ico/ico_duplicate.svg';
import ico_ia_stars from '../../../../assets/ico/ico_ia_3_stars.svg';

const Document = ({ capacity, id, name, item, title_Create, ruleCatalog_Open, ruleGroup_Update, ruleGroup_Delete, ruleGroup_ZoneUrba_Update, ruleGroup_Duplicate }) => {

    const handleTitleChange = (newTitle) => {
        if (name !== newTitle) {
            ruleGroup_Update(id, newTitle, "Renommage de l'ensemble de règles '" + name + "' en", newTitle, false);
        }
    }

    // Document actions
    const [isActions, setIsActions] = useState(false);
    const [isDelete, setIsDelete] = useState(false);
    const [isDuplicate, setIsDuplicate] = useState(false);

    const handleClickTitle = () => {
        title_Create(id);
        setIsActions(false);
    }

    const handleClickRule = () => {
        ruleCatalog_Open(id, "rule");
        setIsActions(false);
    }

    const handleClickDelete = () => {
        setIsActions(false);
        setIsDelete(true);
    }

    const handleClickDuplicate = () => {
        ruleGroup_Duplicate(id);
        setIsDuplicate(false);
    }

    // Zones Urba
    const [zonesUrba, setZonesUrba] = useState(item?.zonesUrba || []);
    const [isZonesUrbaOpen, setIsZonesUrbaOpen] = useState(false);

    const handleZoneUrbaClick = (zoneUrba_id) => {
        // REMOVE
        if (zonesUrba.includes(zoneUrba_id)) {
            var zonesUrba_new = [];
            zonesUrba.forEach((zu_id) => {
                if (zu_id !== zoneUrba_id) { zonesUrba_new.push(zu_id) }
            })
            setZonesUrba(zonesUrba_new);
        }
        // ADD
        else {
            var zonesUrba_new = JSON.parse(JSON.stringify(zonesUrba));
            zonesUrba_new.push(zoneUrba_id);
            setZonesUrba(zonesUrba_new);
        }
    }
    // useEffect(() => {
    //     console.log("UPDATED ZONE URBA SELECTION", zonesUrba);
    // }, [zonesUrba]);

    const handleZoneUrbaValidate = () => {
        if (!item?.zonesUrba || zonesUrba.join("__") !== item.zonesUrba.join("__")) {
            ruleGroup_ZoneUrba_Update(id, zonesUrba);
        }
        setIsZonesUrbaOpen(false);
    }

    return (
        <div className={`app__ruleset_document ${item?.isFromAI ? "app__ruleset_document_AI" : ""}`}>
            <div className="app__ruleset_document_header">
                {/* <div className="app__ruleset_document_title">{name}</div> */}
                {/* {(item?.numerotation && item?.numerotation !== "0.") &&
                    <span className="app__ruleset_document_title_numerotation">{item?.numerotation}</span>
                } */}
                <input id={id + "_title"} className="app__ruleset_document_title_input" type="text" name="title" placeholder="Titre de l'ensemble de règles" onChange={(e) => { }} onBlur={(e) => { handleTitleChange(e.target.value) }} defaultValue={name}></input>
                <div className="app__ruleset_document_button_container" style={{ right: (id !== "doc_0" && id !== "ruleGroup_0") ? '20px' : '0px' }} onClick={() => { setIsDuplicate(true) }}>
                    <img src={ico_duplicate} alt="dots" />
                </div>
                {id !== "doc_0" && id !== "ruleGroup_0" &&
                    <div className="app__ruleset_document_button_container" onClick={() => { setIsDelete(true) }}>
                        <img src={ico_close} alt="dots" />
                    </div>
                }
                {item?.isFromAI &&
                    <div className="app__ruleset_info_from_IA" style={{ top: '-14px', left: '0px' }}>
                        <img src={ico_ia_stars} />
                        <div className="app__ruleset_info_from_IA_text">Généré par IA</div>
                    </div>
                }
            </div>
            {isActions &&
                <div className="app__ruleset_document_actions_container scale-up-topright" onMouseLeave={() => { setIsActions(false) }}>
                    <div className="app__landsvalidation_popup_button" onClick={handleClickTitle}>+ Ajouter un titre</div>
                    <div className="app__landsvalidation_popup_button" onClick={handleClickRule}>+ Ajouter une règle</div>
                    {id !== "doc_0" && id !== "ruleGroup_0" &&
                        <div className="app__landsvalidation_popup_button_second" style={{ marginTop: "6px" }} onClick={handleClickDelete}>Supprimer cet ensemble de règles</div>
                    }
                </div>
            }
            {isDelete &&
                <div className="app__ruleset_document_actions_container" style={{ height: (document.getElementById(id + "_container").offsetHeight + 15) + "px" }}>
                    <div className="app__bound_type_modify_title_big" style={{ color: "#062134", fontWeight: "600" }}>Supprimer cet ensemble de règles ?</div>
                    <div className="app__ruleset_document_deletion_container">
                        <div className="app__landsvalidation_popup_button" onClick={() => { setIsDelete(false) }}>Conserver</div>
                        <div className="app__landsvalidation_popup_button_second" onClick={() => { ruleGroup_Delete(id) }}>Supprimer</div>
                    </div>
                </div>
            }
            {isDuplicate &&
                <div className="app__ruleset_document_actions_container" style={{ height: (document.getElementById(id + "_container").offsetHeight + 15) + "px" }}>
                    <div className="app__bound_type_modify_title_big" style={{ color: "#062134", fontWeight: "600" }}>Dupliquer cet ensemble de règles ?</div>
                    <div className="app__ruleset_document_deletion_container">
                        <div className="app__landsvalidation_popup_button" onClick={() => { handleClickDuplicate() }}>Dupliquer</div>
                        <div className="app__landsvalidation_popup_button_second" onClick={() => { setIsDuplicate(false) }}>Annuler</div>
                    </div>
                </div>
            }
            {capacity?.isModel === true &&
                <div style={{ position: 'relative' }}>
                    <div className="app__ruleset_document_zones_container" onClick={() => { setIsZonesUrbaOpen(true) }}>
                        <div className="app__ruleset_document_zones_title">Zones PLU :</div>
                        <div className="app__ruleset_document_zones_tags">
                            {!item?.zonesUrba || item.zonesUrba.length === 0 ?
                                <span className="app__ruleset_document_zones_tags_item">Toutes les zones</span>
                                :
                                <>
                                    {capacity?.rules?.gpu_data?.zoneUrba_all.map((zoneUrba_data, zoneUrba_index) => {
                                        if (zonesUrba.includes(zoneUrba_data?.properties?.id)) {
                                            return (
                                                <span className="app__ruleset_document_zones_tags_item">{zoneUrba_data?.properties?.libelle || "Zone"}</span>
                                            )
                                        }
                                    })}
                                    {(capacity?.rules?.gpu_data?.zoneUrba2_all && capacity?.rules?.gpu_data?.zoneUrba2_all.length > 0) &&
                                        <>
                                            {capacity?.rules?.gpu_data?.zoneUrba2_all.map((zoneUrba_data, zoneUrba_index) => {
                                                if (zonesUrba.includes(zoneUrba_data?.properties?.id)) {
                                                    return (
                                                        <span className="app__ruleset_document_zones_tags_item">{zoneUrba_data?.properties?.libelle || "Zone"}</span>
                                                    )
                                                }
                                            })}
                                        </>
                                    }
                                    {(capacity?.rules?.gpu_data?.zoneCity_all && capacity?.rules?.gpu_data?.zoneCity_all.length > 0) &&
                                        <>
                                            {capacity?.rules?.gpu_data?.zoneCity_all.map((zoneUrba_data, zoneUrba_index) => {
                                                if (zonesUrba.includes(zoneUrba_data?.properties?.id)) {
                                                    return (
                                                        <span className="app__ruleset_document_zones_tags_item">{zoneUrba_data?.properties?.libelle || "Commune"}</span>
                                                    )
                                                }
                                            })}
                                        </>
                                    }
                                </>
                            }
                        </div>
                    </div>
                    {isZonesUrbaOpen &&
                        <div className="app__ruleset_document_zones_selection_container scale-up-top" onMouseLeave={handleZoneUrbaValidate}>
                            <div className="app__ruleset_document_zones_selection_title_container">
                                <div className="app__ruleset_document_zones_selection_title">Zones principales</div>
                                <div className="app__ruleset_document_zones_selection_title">Zones secondaires</div>
                                <div className="app__ruleset_document_zones_selection_title">Communes</div>
                            </div>
                            <div className="app__ruleset_document_zones_selection_list_container">
                                <div className="app__ruleset_document_zones_selection_list_column">
                                    {/* <div className="app__ruleset_document_zones_selection_list_item">Toutes les zones</div> */}
                                    {capacity?.rules?.gpu_data?.zoneUrba_all.map((zoneUrba_data, zoneUrba_index) => {
                                        return (
                                            <div className={`app__ruleset_document_zones_selection_list_item ${zonesUrba.includes(zoneUrba_data?.properties?.id) ? "app__ruleset_document_zones_selection_list_item_selected" : ""}`} onClick={() => { handleZoneUrbaClick(zoneUrba_data?.properties?.id) }}>{zoneUrba_data?.properties?.libelle || "Zone"}</div>
                                        )
                                    })}
                                </div>
                                <div className="app__ruleset_document_zones_selection_list_column">
                                    {(capacity?.rules?.gpu_data?.zoneUrba2_all && capacity?.rules?.gpu_data?.zoneUrba2_all.length > 0) &&
                                        <>
                                            {capacity?.rules?.gpu_data?.zoneUrba2_all.map((zoneUrba_data, zoneUrba_index) => {
                                                return (
                                                    <div className={`app__ruleset_document_zones_selection_list_item ${zonesUrba.includes(zoneUrba_data?.properties?.id) ? "app__ruleset_document_zones_selection_list_item_selected" : ""}`} onClick={() => { handleZoneUrbaClick(zoneUrba_data?.properties?.id) }}>{zoneUrba_data?.properties?.libelle || "Zone"}</div>
                                                )
                                            })}
                                        </>
                                    }
                                </div>
                                <div className="app__ruleset_document_zones_selection_list_column">
                                    {(capacity?.rules?.gpu_data?.zoneCity_all && capacity?.rules?.gpu_data?.zoneCity_all.length > 0) &&
                                        <>
                                            {capacity?.rules?.gpu_data?.zoneCity_all.map((zoneUrba_data, zoneUrba_index) => {
                                                return (
                                                    <div className={`app__ruleset_document_zones_selection_list_item ${zonesUrba.includes(zoneUrba_data?.properties?.id) ? "app__ruleset_document_zones_selection_list_item_selected" : ""}`} onClick={() => { handleZoneUrbaClick(zoneUrba_data?.properties?.id) }}>{zoneUrba_data?.properties?.libelle || "Commune"}</div>
                                                )
                                            })}
                                        </>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                </div>
            }
        </div>
    );
};

export default Document;